"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function TickInCircleIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M12,23.161A11.161,11.161,0,1,1,23.161,12,11.173,11.173,0,0,1,12,23.161ZM12,2.538A9.462,9.462,0,1,0,21.461,12,9.472,9.472,0,0,0,12,2.538Z" }),
        react_1.default.createElement("path", { d: "M10.282,16.369a.845.845,0,0,1-.6-.249l-3.6-3.6,1.2-1.2,3,3L16.72,7.88l1.2,1.2L10.882,16.12A.842.842,0,0,1,10.282,16.369Z" })));
}
exports.default = TickInCircleIcon;
